import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

const OfferLetterService = {
 
  getOfferLetterByUserId: async (userId) => {
    try {
      const response = await axios.get(`${ENDPOINT.employeeofferletter}/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching offer letter:", error);
      throw error;
    }
  },


  createOfferLetter: async (payload) => {
    try {
      const response = await axios.post(`${ENDPOINT.employeeofferletter}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creating offer letter:", error);
      throw error;
    }
  },

  updateOfferLetter: async (userId, payload) => {
    try {
      const response = await axios.put(`${ENDPOINT.employeeofferletter}/${userId}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating offer letter:", error);
      throw error;
    }
  },

//   deleteOfferLetter: async (userId) => {
//     try {
//       const response = await axios.delete(`${ENDPOINT.employeeofferletter}/${userId}`);
//       return response.data;
//     } catch (error) {
//       console.error("Error deleting offer letter:", error);
//       throw error;
//     }
//   },
};

export default OfferLetterService;
